import React from 'react';
import { makeStyles } from 'src/makeStyles';
import isEmpty from 'lodash/isEmpty';
import { DateFilter } from './dateFilter';
import TextButton from '../../../components/TextButton';
import { dateRangeFilterStyle } from './dateRangeFilterStyle';

const useStyles = makeStyles()(dateRangeFilterStyle);

/**
 * Date range filter is combination of date filters and Today/Tomorrow/plus7 etc
 * Only reason it exists due to reusuablity in multiple pages
 *
 * @param dateFrom
 * @param dateTo
 * @param addDays
 * @returns {JSX.Element}
 * @constructor
 */
export const DateRangeFilter = ({ dateFrom, dateTo, addDays, performanceDateRange }) => {
  const { classes, cx } = useStyles();
  const [daySelection, setDaySelection] = React.useState(null);

  React.useEffect(() => {
    if (isEmpty(dateTo.selectedDay)) {
      setDaySelection(null);
    }
  }, [dateTo]);
  return (
    <>
      <div key="date-from" className={cx(classes.dateFilter, dateFrom.className)}>
        <DateFilter
          id="date_from"
          name="date_from"
          label=""
          className={cx(classes.dateFilterComponent, dateFrom.componentClassName)}
          selectedDay={dateFrom.selectedDay}
          disabledDays={dateFrom.disabledDays}
          onChange={dateFrom.onChange}
          asTag={dateFrom.asTag || 'div'}
          placeholder={dateFrom.placeholder}
          fromMonth={performanceDateRange?.performanceStartDate}
          toMonth={performanceDateRange?.performanceEndDate}
        />
      </div>
      <div key="date-to" className={cx(classes.dateFilter, dateTo.className)}>
        <DateFilter
          id="date_to"
          name="date_to"
          label=""
          className={cx(classes.dateFilterComponent, dateTo.componentClassName)}
          selectedDay={dateTo.selectedDay}
          disabledDays={dateTo.disabledDays}
          onChange={dateTo.onChange}
          asTag={dateTo.asTag || 'div'}
          placeholder={dateTo.placeholder}
          fromMonth={performanceDateRange?.performanceStartDate}
          toMonth={performanceDateRange?.performanceEndDate}
        />
      </div>
      <div key="add-days" className={cx(classes.addDaysGroup, addDays.group.className)}>
        <>
          <input
            type="radio"
            id="today"
            name="today"
            value="today"
            onChange={e => {
              setDaySelection(e.currentTarget.value);
              addDays.today.onChange();
            }}
            checked={daySelection === 'today'}
            className={classes.dayInput}
          />
          <label
            className={cx(classes.addDaysAction, addDays.today.className, classes.todayLabel)}
            htmlFor="today"
          >
            {addDays.today.label}
          </label>
        </>
        <>
          <input
            type="radio"
            id="tomorrow"
            name="tomorrow"
            value="tomorrow"
            onChange={e => {
              setDaySelection(e.currentTarget.value);
              addDays.tomorrow.onChange();
            }}
            checked={daySelection === 'tomorrow'}
            className={classes.dayInput}
          />
          <label
            className={cx(
              classes.addDaysAction,
              addDays.tomorrow.className,
              classes.tomorrowLabel,
            )}
            htmlFor="tomorrow"
          >
            {addDays.tomorrow.label}
          </label>
        </>

        <TextButton
          tabIndex={0}
          className={cx(classes.addDaysAction, addDays.plus7.className)}
          onClick={() => {
            setDaySelection(null);
            addDays.plus7.onClick();
          }}
        >
          {addDays.plus7.label}
        </TextButton>
        <TextButton
          tabIndex={0}
          className={cx(classes.addDaysAction, addDays.plus14.className)}
          onClick={() => {
            setDaySelection(null);
            addDays.plus14.onClick();
          }}
        >
          {addDays.plus14.label}
        </TextButton>
        <TextButton
          tabIndex={0}
          className={cx(classes.addDaysAction, addDays.plus30.className)}
          onClick={() => {
            setDaySelection(null);
            addDays.plus30.onClick();
          }}
        >
          {addDays.plus30.label}
        </TextButton>
      </div>
    </>
  );
};
